export const bookmakerNames = {
    coral: 'coral',
    ladbrokes: 'ladbrokes',
    paddyPower: 'paddyPower',
    betfair: 'betfair',
    williamHill: 'williamHill',
    bet365: 'bet365',
    skybet: 'skybet',
    bestOdds: 'BestOdds',
    betfred: 'Betfred',
    boyleSports: 'BoyleSports',
    betVictor: 'BetVictor',
    tote: 'TOTE',
}



// WEBPACK FOOTER //
// /src/js/common/utils/constants/bookmakers.js